import { render, staticRenderFns } from "./OfferSummary.vue?vue&type=template&id=40b656cc"
import script from "./OfferSummary.vue?vue&type=script&lang=js"
export * from "./OfferSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports